import { animationFrameScheduler, of, timer } from 'rxjs';
import {
    auditTime,
    catchError,
    filter,
    retryWhen,
    scan,
    switchMap,
    take,
    tap,
} from 'rxjs/operators';

import { scrollIntoViewInstant } from '../../../../../coaching-observation/bring-into-focus.service';
import { useSelector2 } from '../../../../store-use-selector';
import { TranscriptSummaryState } from '../transcript-summary.state';

export function scrollTranscriptIntoView(transcriptId: number): void {
    useSelector2<{ reload?: boolean }>(
        (state) =>
            (state?.coachingDetail?.transcriptSummary as TranscriptSummaryState)
                ?.pending,
    )
        .pipe(
            filter(
                ([prevState, state]) =>
                    prevState?.reload === true && state?.reload !== true,
            ),
            take(1),
            switchMap(() => timer(500)),
            tap(() => {
                const el = document.querySelector(
                    `.cmps-coaching-detail-pillar-two-transcript-summary .cmps-scrollbar--content > .cmps-accordion > .cmps-accordion-item .cmps-coaching-activity-status-wrapper .cmps-accordion-item[data-transcript-id="${transcriptId}"]`,
                );
                const sel = document.querySelector(
                    '.cmps-coaching-detail-pillar-two-transcript-summary .cmps-scrollbar--content-wrapper',
                );
                scrollIntoViewInstant(el, sel);
            }),
            retryWhen((errors) =>
                errors.pipe(
                    scan((acc) => {
                        if (acc >= 5) {
                            throw new Error('still not found');
                        }
                        return acc + 1;
                    }, 0),
                    auditTime(0, animationFrameScheduler),
                ),
            ),
            catchError(() => of(null)),
        )
        .subscribe();
}
